import React from "react";
import type { RouteObject } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import SustainabilityPage from "../pages/sustainability/page";
import PrivacyPolicyPage from "../pages/privacy/page";
import TermsOfServicePage from "../pages/terms/page";
import CheckoutPage from "../pages/checkout/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:productId",
    element: <ProductPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/sustainability",
    element: <SustainabilityPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    // Catch‑all route for undefined paths
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
